<script setup lang="ts">
// TODO:
// - Input type + autocomplete stuff
// - Checkboxes for accepting privacy etc
// - Add gender?
// - Set labels on form schema

import { object, string } from 'yup'

useLocalizedPageTitle('Registreren als vrijwilliger', 'Sign up as a volunteer')

definePageMeta({
  isPublic: true,
})

const { t } = useI18n({
  useScope: 'local',
})
const { t: $t } = useI18n({
  useScope: 'global',
})

const schema = object({
  firstName: string().required().label($t('user.attributes.firstName')),
  lastName: string().required().label($t('user.attributes.lastName')),
  email: string().required().label($t('user.attributes.email')), // TODO: email validation?
  phoneNumber: string().label($t('user.attributes.phoneNumber')), // TODO: phone number validation
  password: string().required().label($t('user.attributes.password')),
  passwordConfirmation: string()
    .required()
    .label($t('user.attributes.passwordConfirmation')),
})

const validationSchema = toTypedSchema(schema)

// const initialValues = {}
const initialValues = process.dev
  ? {
      firstName: 'Gertjan',
      lastName: 'Jansen',
      email: 'gertjan.jansen@gmail.com',
      password: 'password',
      passwordConfirmation: 'password',
    }
  : {}

const { handleSubmit, isSubmitting, setFieldError, resetForm } = useForm({
  validationSchema,
  initialValues,
})

const router = useRouter()
const success = ref(false)

const { toast } = useSuccessToaster()

const { handleServerError } = useServerErrorHandler(schema, setFieldError)
const { handleValidationError } = useFormValidationErrorHandler()

const onSubmit = handleSubmit(async (values) => {
  success.value = false

  try {
    const user = await signUpVolunteer(values)
    console.log('user', user)

    resetForm()

    router.push(`/signup/success/?id=${user.id}`)

    toast({
      title: 'Registratie gelukt!',
      message: `Aanmelding geslaagd! Je ontvangt een bevestigingsmail.`,
    })
  }
  catch (error) {
    handleServerError(error)
  }
}, handleValidationError)
</script>

<template>
  <FormCard
    :is-submitting="isSubmitting"
    icon="ph:user"
    :title="t('title')"
    :sub-title="t('subTitle')"
    :show-cancel-button="false"
    :submit-label="$t('signUp')"
    @submit="onSubmit"
  >
    <FormField
      name="firstName"
      :label="$t('user.attributes.firstName')"
      :placeholder="$t('user.placeholders.firstName')"
    />
    <FormField
      name="lastName"
      :label="$t('user.attributes.lastName')"
      :placeholder="t('user.placeholders.lastName')"
    />
    <FormField
      name="phoneNumber"
      :label="$t('user.attributes.phoneNumber')"
      :placeholder="$t('user.placeholders.phoneNumber')"
    />
    <FormField
      name="email"
      type="email"
      :label="$t('user.attributes.email')"
      :placeholder="t('user.placeholders.email')"
    />
    <FormField
      name="password"
      type="password"
      :label="$t('user.attributes.password')"
      :placeholder="$t('user.placeholders.password')"
    />
    <FormField
      name="passwordConfirmation"
      type="password"
      :label="$t('user.attributes.passwordConfirmation')"
      :placeholder="$t('user.placeholders.passwordConfirmation')"
    />
  </FormCard>
</template>

<i18n lang="json">
{
  "en": {
    "title": "Sign up as volunteer",
    "subTitle": "Enter your details to create an account."
  },
  "nl": {
    "title": "Registreer je als vrijwilliger",
    "subTitle": "Vul je gegevens in om een account aan te maken."
  }
}
</i18n>
